import LockRoundedIcon from '@mui/icons-material/LockRounded'
import { Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'

import { useAuth } from '@/features/auth/hooks/useAuth'
import { hasPermission, type Permission } from '@/features/auth/permissions'

export function PermissionRoute({ permission, children }: { permission: Permission; children: ReactNode }) {
  const { user } = useAuth()

  if (!hasPermission(user?.role, permission)) {
    return (
      <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ minHeight: '60vh', textAlign: 'center' }}>
        <LockRoundedIcon sx={{ fontSize: 40, color: 'text.disabled' }} />
        <Typography variant="h6">No tienes permisos para ver esta sección</Typography>
        <Typography variant="body2" color="text.secondary">
          Solicita acceso a un administrador de tu organización si crees que esto es un error.
        </Typography>
      </Stack>
    )
  }

  return children
}
